import { GOOGLE_MAP_LOADED } from '@location/actionTypes';

const onGoogleMapLoaded = () => ({ type: GOOGLE_MAP_LOADED });

export default onGoogleMapLoaded;
